import {isNil} from 'lodash';

const isNilOrEmpty = (val: any) => isNil(val) || val === '';

/*
 * Check if every element in the array is nil or empty.
 */
export const isNilArray = (arr: any[]) => {
  if (Array.isArray(arr)) {
    return arr.every(isNilOrEmpty);
  }
  return false;
};
